import React from 'react';
import { fallbackSrc, srcSet } from '@/lib/images';

/**
 * Responsivt bilde: AVIF først, WebP som reserve, valgfri stående variant for smale skjermer.
 * `priority` brukes kun på hero (eager + høy prioritet); alt annet lastes lat og dekodes asynkront.
 * `<picture>` rendres med `display: contents`, slik at img-elementet styres av forelderens layout.
 */
export function Picture({ variant, portrait, portraitMedia = '(max-width: 767px)', sizes = '100vw', portraitSizes = '100vw', alt = '', priority = false, loading, className, style, imgRef, ...rest }) {
  return (
    <picture className="contents">
      {portrait && (
        <>
          <source media={portraitMedia} type="image/avif" srcSet={srcSet(portrait, 'avif')} sizes={portraitSizes} width={portrait.width} height={portrait.height} />
          <source media={portraitMedia} type="image/webp" srcSet={srcSet(portrait, 'webp')} sizes={portraitSizes} width={portrait.width} height={portrait.height} />
        </>
      )}
      <source type="image/avif" srcSet={srcSet(variant, 'avif')} sizes={sizes} />
      <img
        ref={imgRef}
        src={fallbackSrc(variant)}
        srcSet={srcSet(variant, 'webp')}
        sizes={sizes}
        width={variant.width}
        height={variant.height}
        alt={alt}
        loading={priority ? 'eager' : loading ?? 'lazy'}
        fetchPriority={priority ? 'high' : undefined}
        decoding={priority ? 'sync' : 'async'}
        className={className}
        style={style}
        draggable={false}
        {...rest}
      />
    </picture>
  );
}
